import React from 'react';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { SpecifiedEventV2FormValues } from '../../modals/SpecifiedEventExclusionV2Modal';
import { SpecifiedEventExclusionV2ModalConfig } from '../../modals/SpecifiedEventExclusionV2Modal';
import type { EventExclusionV2 } from '../../../../../../api/types/rater-x-preset';

const SpecifiedEventExclusionV2 = (props: AmendatoryLineItemProps) => {
  const handleAddExclusion = (formValues: SpecifiedEventV2FormValues) => {
    const _exclusions = formatEventExclusionsV2ForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: {
          exclusions: { values: _exclusions as unknown as EventExclusionV2[] },
        },
      },
    });
  };

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(SpecifiedEventExclusionV2ModalConfig, {
          data: {
            onSubmit: handleAddExclusion,
            exclusions: getDefaultEventExclusionV2Values(
              props.value?.props?.exclusions?.values as EventExclusionV2[]
            ),
          },
        })}
      >
        Add/Edit ({String(props.value?.props?.exclusions?.values?.length ?? 0)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default SpecifiedEventExclusionV2;

export function getDefaultEventExclusionV2Values(
  values: EventExclusionV2[] | undefined
) {
  if (!values) {
    return [];
  }

  return values.map((value) => ({
    eventReference: value.props.eventReference.value ?? '',
    eventDescription: value.props.eventDescription.value ?? '',
  }));
}

export function formatEventExclusionsV2ForState(
  formValues: SpecifiedEventV2FormValues
) {
  return formValues.exclusions.map((exclusion) => ({
    props: Object.keys(exclusion).reduce((acc, key) => {
      const value = exclusion[key as keyof typeof exclusion];
      return {
        ...acc,
        [key]: { value },
      };
    }, {} as EventExclusionV2),
  }));
}
